// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"117":"d9e59774","453":"168512b2","581":"5e72e4b5","645":"c56fb46f"}[chunkId] + ".chunk.js";
};